export default function fileReadAsBase64Async(blob) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      const dataUrl = fileReader.result;
      const base64 = dataUrl.split(",")[1];
      resolve(base64);
    };
    fileReader.onerror = (err) => {
      reject(err);
    };
    fileReader.readAsDataURL(blob);
  });
}
